import { uuid } from "vue-uuid";
import { post } from "../base";

import { ClientRequest } from "../ClientRequest.js";
import { Petition } from "../Petition.js";
import { PATH } from "@/utils/shared";

const API_SERVICE_FORGOT = "/v1/restablecer";
const API_SERVICE_RESET = "/v1/reset";

export default {
  login: (credentials) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "gbl_validar_acceso_usuario");
    _petition.add_item("USUARIO", credentials.usuario);
    _petition.add_item("PASSWORD", credentials.constrasenia);

    _request.petitions.push(_petition);

    return post("/v1/login", _request);
  },

  validarGoogle2FA: (credentials) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.add_item("script", "gbl_validar_acceso_usuario");
    _petition.add_item("USUARIO", credentials.usuario);
    _petition.add_item("CODIGO", credentials.codigo);

    _request.petitions.push(_petition);

    return post("/v1/validateauthentication", _request);
  },

  forgot: (payload) => {
    var codigo = uuid.v4().slice(0, 6);

    var response = {
      formato: "formato_estandar_restablecer",
      script: "q_public_formato_estandar_bienvenida",
      CORREO: payload.correo,
      CODIGO: codigo
    };

    return post(API_SERVICE_FORGOT, response);
  },

  recover: (payload) => {
    var response = {
      store: "fn_validate_recover_password",
      EMAIL_OLD: payload.correo,
      CODIGO_OLD: payload.codigo,
      PASSWORD_OLD: payload.password
    };

    return post(API_SERVICE_RESET, response);
  },

  logout: (usuario) => {
    var _request = new ClientRequest();
    var _petition = new Petition();

    _petition.type = 2;
    _petition.table = "seg_sesion";
    _petition.condition = "";
    _petition.transaction = false;

    _petition.add_item("usuarioingreso", usuario);
    _petition.add_item("usuario", usuario);
    _petition.add_item("accion", "CERRAR SESIÓN DE USUARIO");
    // _petition.add_item("idtiposesion", "1", "int");
    // _petition.add_item("idsistema", "2", "int");

    _request.petitions.push(_petition);
    return post(PATH.API_SERVICE, _request);
  },

  getModulos: () => post("v1/auth/roles", { SISTEMA: "SYCA" }),

  subirFoto: (path) => post("v1/service/DescargarImagen", { url: path, connectTo: "SRVSQL_SYCA" })
};
